module.exports = __webpack_public_path__ + "assets/img/visualization_2.ef029d9b.png";